import React, { Component } from "react";
import axios from "axios";
import { BASE_URL, HEADERS } from "../../common/api";
import ClientTable from "../../assets/js/ClientTabe"; // Импортируем новый компонент

const columns = [
  { field: "id", header: "ИД" },
  { field: "name", header: "Имя" },
  { field: "product_vid", header: "Дизайн" },
  { field: "meet_data", header: "Дата встречи" },
  { field: "meet_time", header: "Врема для встречи" },
  { field: "comment", header: "Коментарии" },
  { field: "phone", header: "Телефон" },
  { field: "social_acc", header: "Социальная сеть" },
];

export class ConsultetionLead extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loading: true,
      error: null,
    };
  }

  componentDidMount() {
    this.fetchConsultationLeads();
  }

  fetchConsultationLeads = () => {
    axios
      .get(BASE_URL + "consultations/", HEADERS)
      .then((res) => {
        this.setState({
          data: res.data,
          loading: false,
        });
      })
      .catch((error) => {
        console.error("Ошибка загрузки клиентов:", error);
        this.setState({
          error: "Не удалось загрузить данные клиентов",
          loading: false,
        });
      });
      
  };

  handleView = (row) => {
    console.log("Просмотр клиента:", row);
    // Логика просмотра
  };

  // handleEdit = (row) => {
  //   console.log("Редактирование клиента:", row);
  //   // Логика редактирования
  // };

  // handleDelete = (row) => {
  //   if (window.confirm(`Удалить клиента ${row.first_name} ${row.last_name}?`)) {
  //     console.log("Удаление клиента:", row);
  //     // Логика удаления
  //   }
  // };

  render() {
    const { data, loading, error } = this.state;
    console.log(data);
    

    if (loading) {
      return (
        <div className="text-center p-5">
          <div className="spinner-border" role="status">
            <span className="sr-only">Загрузка...</span>
          </div>
        </div>
      );
    }

    if (error) {
      return <div className="alert alert-danger m-3">{error}</div>;
    }

    return (
      <div className="container-fluid p-4">
        <ClientTable
          data={data}
          columns={columns}
          title="Запис консултацию"
          onView={this.handleView}
          // onEdit={this.handleEdit}
          // onDelete={this.handleDelete}
        />
      </div>
    );
  }
}

export default ConsultetionLead;